import { APPEND_PROJECTS, REMOVE_PROJECTS } from "./actionTypes";

export const setProjectsData = (data) => {
  return {
    type: APPEND_PROJECTS,
    projects: data,
  };
};

export const removeProjectsData = () => {
  return {
    type: REMOVE_PROJECTS,
  };
};
